import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = { class: "table-caption" };
const _hoisted_5 = { class: "q-mb-lg entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    ...(_ctx.hasAddress
                        ? [
                            { itemId: _ctx.PageID.top },
                            { itemId: _ctx.PageID.keiyaku },
                            { itemId: _ctx.PageID.mailaddressChange }
                        ]
                        : [{ itemId: _ctx.PageID.mailaddressConfig }])
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.hasAddress ? "新しいメールアドレスを入力してください。" : "メールアドレスを入力してください"), 1),
                                    _createElementVNode("table", _hoisted_5, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[3] || (_cache[3] = _createTextVNode("メールアドレス ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.mailAddress,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.mailAddress) = $event)),
                                                        color: "positive",
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.mailAddress.error,
                                                        "error-message": _ctx.valid.mailAddress.message
                                                    }, null, 8, ["modelValue", "error", "error-message"])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                (_ctx.hasAddress)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        label: "戻る",
                                        class: "btn-route col-5 col-md-3",
                                        color: "grey-8",
                                        icon: "navigate_before",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.back()))
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_q_btn, {
                                    label: "変更",
                                    class: "btn-route col-5 col-md-3",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.submit
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
